// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cx6I","rootNoMargin":"styles_rootNoMargin__1TorF"};